@use './z-index';

/* stylelint-disable-next-line selector-pseudo-class-no-unknown */
:export {
  /* stylelint-disable-next-line property-no-unknown */
  tooltip: z-index.$tooltip;
}
